import { PrepOption } from "@deliverr/business-types";

export const PREP_OPTIONS_WITH_UNIT_BARCODING = [
  PrepOption.SKU_LABELS,
  PrepOption.BAGGING_PROTECTION,
  PrepOption.DAMAGE_PROTECTION,
];
